/**
 * Header Layout
 *
 * @file header.js
 */

import $ from 'jquery';

const header = (() => {
  const openMenu = () => {
    $(".header-right li").hover(function(){
      $(this).parents("ul").find("li").addClass("hovers");
      $(this).addClass("not-hover");
    },function(){
      $(this).parents("ul").find("li").removeClass("hovers");
      $(this).removeClass("not-hover");
    });
    $(".header-right .menu ul li").each(function(){
      if($(this).find(".sub-menu").length == 1){
        $(this).addClass("no-line-border");
      }
    });
    $(".header-right .menu ul li").hover(function(){
      $(this).children(".mn-menu").addClass("active");
    }, function(){
      $(this).children(".mn-menu").removeClass("active");
    });
  };

  const fixedHeader = () => {
    $(window).scroll(function(){
      if($(window).scrollTop() > 50){
        $("header").addClass("white-bg");
      } else {
        $("header").removeClass("white-bg");
      }
    });
    if($(window).scrollTop() > 50){
      $("header").addClass("white-bg");
    } else {
      $("header").removeClass("white-bg");
    }
    // $("header").hover(function(){
    //   $(this).addClass("white-bg");
    // }, function(){
    //   $(this).removeClass("white-bg");
    // })
    if ($(".slide-left-share-navigation .left .sh")){
      $(".slide-left-share-navigation .left .sh").on("click", function(){
        $(this).addClass("active");
        $(".slide-left-share-navigation .left .ml").addClass("active");
        $(".slide-left-share-navigation").addClass("active");
      });
      $(".slide-left-share-navigation .bg").on("click", function(){
        $(".slide-left-share-navigation .left .sh").removeClass("active");
        $(".slide-left-share-navigation .left .ml").removeClass("active");
        $(".slide-left-share-navigation").removeClass("active");
      })
    }
  };

  const mobileOpenMenu = () => {
    $(".mobile-menu").on("click", function(){
      $(".mobile-menu-toggle").toggle();
      $("html").toggleClass("hide");
    });
  };

  const fullSearch = () => {
    $(".header-right .search, .mobile-search").on("click", function(){
      $(".full-search").toggleClass("active");
      $("html").toggleClass("hide");
    });
    $(".full-search .bg").on("click", function(){
      $(".full-search").removeClass("active");
      $("html").removeClass("hide");
    });
  };

  const detailPageAnchor = () => {
    if($(window).scrollTop() >= 420){
      $(".right-fix-menu").addClass("active");
    } else{
      $(".right-fix-menu").removeClass("active");
    }
    $(window).scroll(function(){
      if($(window).scrollTop() >= 420){
        $(".right-fix-menu").addClass("active");
      } else{
        $(".right-fix-menu").removeClass("active");
      }
    });
    $(".right-fix-menu .item").on("click", function(){
      var aTag = $(this).attr("href");
      $('html,body').animate({scrollTop: $(aTag).offset().top - 70},'slow');
    });
  };

  // const lazyImage = () =>{
  //   document.addEventListener("DOMContentLoaded", function() {
  //     var lazyloadImages = document.querySelectorAll("img.lazy");    
  //     var lazyloadThrottleTimeout;
      
  //     function lazyload () {
  //       if(lazyloadThrottleTimeout) {
  //         clearTimeout(lazyloadThrottleTimeout);
  //       }    
        
  //       lazyloadThrottleTimeout = setTimeout(function() {
  //           var scrollTop = window.pageYOffset;
  //           lazyloadImages.forEach(function(img) {
  //               if(img.offsetTop < (window.innerHeight + scrollTop)) {
  //                 img.src = img.dataset.src;
  //                 img.classList.remove('lazy');
  //               }
  //           });
  //           if(lazyloadImages.length == 0) { 
  //             document.removeEventListener("scroll", lazyload);
  //             window.removeEventListener("resize", lazyload);
  //             window.removeEventListener("orientationChange", lazyload);
  //           }
  //       }, 20);
  //     }
      
  //     document.addEventListener("scroll", lazyload);
  //     window.addEventListener("resize", lazyload);
  //     window.addEventListener("orientationChange", lazyload);
  //   });
  // <img class="lazy" data-src="https://ik.imagekit.io/demo/img/image10.jpeg?tr=w-400,h-300" />
  // }

  const init = () => {
    openMenu();
    fixedHeader();
    mobileOpenMenu();
    fullSearch();
    detailPageAnchor();
    // lazyImage();
  };

  return {
    init,
  };
})();

export default header;
